import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { Bid } from '@app/models';

export const {
  initialState: bidInitialState,
  selectors: bidSelectors,
  facade: BidFacadeBase,
} = buildState(Bid);

export function bidReducer(state = bidInitialState): IEntityState<Bid> {
  return state;
}
